import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LexwareContact } from 'src/app/interfaces/orders';
import { DataServerService } from 'src/app/services/api/data-server.service';
import { AlertService } from 'src/app/services/base/alert.service';
import { SessionService } from 'src/app/services/manager/session.service';
import { CoreService } from 'src/app/services/manager/core.service';
@Component({
  selector: 'app-convert-contact',
  templateUrl: './convert-contact.component.html',
  styleUrls: ['./convert-contact.component.scss'],
  standalone: false,
})
export class ConvertContactComponent implements OnInit {
  @Input() data: any; // Input für übergebene Daten (Google oder Lexware Contact)
  formData = {
    id: null as number | null,
    companyName: '',
    website: '',
    email: '',
    phone: '',
    contactPerson: {
      salutation: '',
      firstName: '',
      lastName: '',
      emailAddress: '',
      phoneNumber: '',
    },
    address: {
      supplement: '',
      street: '',
      zip: '',
      city: '',
    },
    delivery: {
      companyName: '',
      contactPerson: '',
      supplement: '',
      street: '',
      zip: '',
      city: '',
    },
    note: '',
    deactivated: false
  };


  constructor(
    private modalCtrl: ModalController,
    private dataServer: DataServerService,
    private alert: AlertService,
    private session: SessionService,
    private core: CoreService
  ) {}

  ngOnInit(): void {
    if (this.data?.google) {
      this.mapGoogleToFormData(this.data.google);
    }
    else if (this.data?.lexware) {
      this.formData = this.data.lexware; // Fülle das Formular mit Lexware-Daten, falls vorhanden
    }
    else if (this.data) {
      // Handle direct contact payload
      this.formData = {
        id: this.data.id || null,
        companyName: this.data.companyName || '',
        website: this.data.website || '',
        email: this.data.email || '',
        phone: this.data.phone || '',
        contactPerson: {
          salutation: this.data.contactPerson?.salutation || '',
          firstName: this.data.contactPerson?.firstName || '',
          lastName: this.data.contactPerson?.lastName || '',
          emailAddress: this.data.contactPerson?.emailAddress || '',
          phoneNumber: this.data.contactPerson?.phoneNumber || '',
        },
        address: {
          supplement: this.data.address?.supplement || '',
          street: this.data.address?.street || '',
          zip: this.data.address?.zip || '',
          city: this.data.address?.city || '',
        },
        delivery: {
          companyName: this.data.delivery?.companyName || '',
          contactPerson: this.data.delivery?.contactPerson || '',
          supplement: this.data.delivery?.supplement || '',
          street: this.data.delivery?.street || '',
          zip: this.data.delivery?.zip || '',
          city: this.data.delivery?.city || '',
        },
        note: this.data.note || '',
        deactivated: this.data.deactivated || false
      };
    }
  }

  // getGoogleContacts() liefert dieselben Contacts-Collection-Datensaetze wie
  // getLexwareContacts() (siehe data-server.service.ts) — Feldnamen entsprechend
  // aus der echten Contacts-Struktur lesen, nicht aus dem alten flachen Google-Format.
  mapGoogleToFormData(contact: any): void {
    this.formData.id = contact.id || null;
    this.formData.companyName = contact.companyName || '';
    this.formData.website = contact.website || '';
    this.formData.email = contact.email || '';
    this.formData.phone = contact.phone || '';
    this.formData.contactPerson.salutation = contact.contactPerson?.salutation || '';
    this.formData.contactPerson.firstName = contact.contactPerson?.firstName || '';
    this.formData.contactPerson.lastName = contact.contactPerson?.lastName || '';
    this.formData.contactPerson.emailAddress = contact.contactPerson?.emailAddress || '';
    this.formData.contactPerson.phoneNumber = contact.contactPerson?.phoneNumber || '';
    this.formData.address.supplement = contact.address?.supplement || '';
    this.formData.address.street = contact.address?.street || '';
    this.formData.address.zip = contact.address?.zip || '';
    this.formData.address.city = contact.address?.city || '';
    this.formData.delivery.companyName = contact.delivery?.companyName || '';
    this.formData.delivery.contactPerson = contact.delivery?.contactPerson || '';
    this.formData.delivery.supplement = contact.delivery?.supplement || '';
    this.formData.delivery.street = contact.delivery?.street || '';
    this.formData.delivery.zip = contact.delivery?.zip || '';
    this.formData.delivery.city = contact.delivery?.city || '';
    this.formData.note = contact.note || '';
  }

  // Verarbeite das Formular und schließe das Modal
  onSubmit(): void {
    const lexwareContact: LexwareContact = {
      owner: this.session.token?.sub || '', // Using the subject from the JWT token
      companyName: this.formData.companyName,
      email: this.formData.contactPerson.emailAddress,
      phone: this.formData.contactPerson.phoneNumber,
      contactPerson: {
        salutation: this.formData.contactPerson.salutation,
        firstName: this.formData.contactPerson.firstName,
        lastName: this.formData.contactPerson.lastName,
        emailAddress: this.formData.contactPerson.emailAddress,
        phoneNumber: this.formData.contactPerson.phoneNumber,
      },
      address: {
        street: this.formData.address.street,
        supplement: this.formData.address.supplement,
        zip: this.formData.address.zip,
        city: this.formData.address.city,
      },
      delivery: {
        companyName: this.formData.delivery.companyName,
        contactPerson: this.formData.delivery.contactPerson,
        supplement: this.formData.delivery.supplement,
        street: this.formData.delivery.street,
        zip: this.formData.delivery.zip,
        city: this.formData.delivery.city,
      },
      note: this.formData.note || '',
      deactivated: false,
    };

    // BYPASS LEX CONTACTS

    const lexwareContact2 = {
      addresses: [
        {
          city: this.formData.address.city,
          countryAlpha2Code: 'DE',
          countryId: 4,
          country: 'Deutschland',
          listTypeId: '38b485a0-07d2-488b-9bb2-0e6ebb531296',
          street: this.formData.address.street,
          supplement: this.formData.address.supplement,
          zip: this.formData.address.zip,
        },
      ],
      archived: false,
      categorySelectionEnabled: false,
      collectiveCustomer: false,
      customer: true,
      individualPerson: false,
      name: this.formData.companyName,
      vendor: false,
      xRechnungEnabled: false,
    };

    // This is the format expected by the Lexware API
    let lexwareContact3 = {
      addresses: [
        {
          city: this.formData.address.city,
          countryAlpha2Code: 'DE',
          countryId: 4,
          country: 'Deutschland',
          listTypeId: '38b485a0-07d2-488b-9bb2-0e6ebb531296',
          street: this.formData.address.street,
          supplement: this.formData.address.supplement,
          zip: this.formData.address.zip,
        },
      ],
      archived: false,
      categorySelectionEnabled: false,
      collectiveCustomer: false,
      customer: true,
      emailAddresses: [
        {
          emailAddress: this.formData.contactPerson.emailAddress,
          listTypeId: '4bb3afbc-5438-48d9-8c07-486b8b6a7698',
          primary: true,
        },
      ],
      individualPerson: false,
      name: this.formData.companyName,
      phoneNumbers: [
        {
          listTypeId: 'c70abd92-c06b-4f26-a038-c779b7127976',
          number: this.formData.contactPerson.phoneNumber,
          primary: true,
        },
      ],
      vendor: false,
      xRechnungEnabled: false,
      note: this.formData.note,
    };

    if (
      !lexwareContact3.emailAddresses[0].emailAddress ||
      lexwareContact3.emailAddresses[0].emailAddress === ''
    ) {
      lexwareContact3.emailAddresses = [];
    }

    if (
      !lexwareContact3.phoneNumbers[0].number ||
      lexwareContact3.phoneNumbers[0].number === ''
    ) {
      lexwareContact3.phoneNumbers = [];
    }

    // Create a new contact object with the structure matching the Payload form
    const lexwareContact4 = {
      id: this.formData.id || null,
      owner: this.session.token?.sub || '',
      companyName: this.formData.companyName,
      email: this.formData.contactPerson.emailAddress || '',
      phone: this.formData.contactPerson.phoneNumber || '',
      website: this.formData.website || '',
      contactPerson: {
        salutation: this.formData.contactPerson.salutation || '',
        firstName: this.formData.contactPerson.firstName || '',
        lastName: this.formData.contactPerson.lastName || '',
        emailAddress: this.formData.contactPerson.emailAddress || '',
        phoneNumber: this.formData.contactPerson.phoneNumber || ''
      },
      address: {
        supplement: this.formData.address.supplement || '',
        street: this.formData.address.street || '',
        zip: this.formData.address.zip || '',
        city: this.formData.address.city || ''
      },
      delivery: {
        companyName: this.formData.delivery.companyName || '',
        contactPerson: this.formData.delivery.contactPerson || '',
        supplement: this.formData.delivery.supplement || '',
        street: this.formData.delivery.street || '',
        zip: this.formData.delivery.zip || '',
        city: this.formData.delivery.city || ''
      },
      note: this.formData.note || '',
      deactivated: this.formData.deactivated || false
    };

    // Use the new contact object that matches the Payload structure
    this.createContact(lexwareContact4);
  }

  async createContact(lexwareContact: any) {
    let res;
    if (lexwareContact.id) {
      // Update existing contact
      const contactId = lexwareContact.id;
      // Create a copy without id/owner for the PATCH request — owner is
      // set server-side only on create (see Contacts.ts beforeChange hook);
      // sending the Lexware JWT's sub here is not a valid users ObjectId
      // and makes Payload fail the relationship cast with a 500.
      const contactData = {...lexwareContact};
      delete contactData.id;
      delete contactData.owner;


      res = await this.dataServer.patchLexwareContact(contactId, contactData);

      if (res.status === 200 || res.status === 201) {
        this.closeModal(lexwareContact); // Schließe das Modal und sende die Daten zurück
        this.core.refreshLexwareContacts();
        this.alert.presentInfoAlert(
          'Erfolg',
          'Kontakt wurde aktualisiert'
        );
      } else {
        this.alert.presentInfoAlert(
          'Kontakt Aktualisierung fehlgeschlagen',
          this.formatPayloadError(res.data)
        );
      }
    } else {
      // Create new contact
      res = await this.dataServer.postLexwareContact(lexwareContact);

      if (res.status === 200 || res.status === 201) {
        this.closeModal(lexwareContact); // Schließe das Modal und sende die Daten zurück
        this.core.refreshLexwareContacts();
        this.alert.presentInfoAlert(
          'Erfolg',
          'Kontakt wurde erstellt'
        );
      } else {
        this.alert.presentInfoAlert(
          'Kontakt Erstellung fehlgeschlagen',
          this.formatPayloadError(res.data)
        );
      }
    }
  }

  // Wandelt Payloads ValidationError-Antwort in eine lesbare Liste von Feld: Grund um
  private formatPayloadError(data: any): string {
    const fieldErrors = data?.errors?.[0]?.data?.errors;
    if (Array.isArray(fieldErrors) && fieldErrors.length > 0) {
      return fieldErrors
        .map((err: any) => `${err.label || err.path}: ${err.message}`)
        .join('\n');
    }

    const fallbackMessage = data?.errors?.[0]?.message;
    return fallbackMessage || JSON.stringify(data);
  }

  closeModal(data?: any): void {
    this.modalCtrl.dismiss(data); // Daten an den Aufrufer zurückgeben
  }
}
